import { Toast } from '@mtfe/sweet-components';
import { getOadParams, oadLX, oadInterceptor } from '@mtfe/pr-oad';
import { getErrorMessage } from '@mtfe/sweet-report';

import { addUserInfoErrorToReport } from '../utils/report';

const { post, get } = oadInterceptor;

const actId = 'cpsRecvCouponOpt';

const recordPointHasDone = {
    reportLocation: false,
    reportApi: false,
};

const _reportLX = (url, error) => {
    oadLX.mv('b_waimai_wunt28uk_mv', {
        custom: {
            url,
            error: error.message || JSON.stringify(error),
        },
    });
};

// 获取用户信息(替换handleCookie)
const getUserInfo = async () => {
    try {
        const rest = await getOadParams();

        const data = {
            ...rest,
        };
        const res = await post({
            url: '/act/ge/getUserInfo',
            data,
            needToLogan: true,
        });

        return res;
    } catch (error) {
        Toast({ message: '获取用户信息失败', position: 'bottom' });
        addUserInfoErrorToReport(getErrorMessage(error, '获取用户信息失败'));
        console.error('获取用户信息异常', error);
    }
};

// 点击上报后端
const actGeClkM = async (clickMonitorUrl) => {
    const url = `https:${clickMonitorUrl}`;
    try {
        const res = await get({
            url,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        console.error('点击上报异常', error);
    }
};
/**
 * 曝光上报后端
 * @param {*} impMonitorUrl
 * @returns
 */
const gMonitorApi = async (impMonitorUrl) => {
    const url = `https:${impMonitorUrl}`;
    try {
        const res = await get({
            url,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};

/**
 * 批量领券
 * @param {*} giftIds
 * @returns
 */
const actGeRecvVer4Multi = async (giftIds, recallBizId = '') => {
    const rest = await getOadParams();
    const data = { ...rest, giftIds };
    const url = '/act/ge/recv_ver4_multi';

    if (recallBizId) {
        data.recallBizId = recallBizId;
    }

    const res = await post({
        url,
        data,
        needToLogan: true,
    });
    return res;
};

/**
 * 组件化poi检索接口
 * @param {*} recallBizId 商家召回逻辑ID
 * @param {*} pageNo 滚动加载页码
 * @returns
 */
const actGetPoiList = async (props = {}) => {
    const rest = await getOadParams();

    // 页面成功获取定位位置
    if (rest && rest.lat && rest.lon && !recordPointHasDone.reportLocation) {
        recordPointHasDone.reportLocation = true;
    }

    const { recallBizId, pageNo, searchKeyword, giftId, pageDivideId } = props;

    const url = '/act/ge/queryPoiByRecallBiz';
    const data = {
        ...rest,
        pageNo,
        recallBizId,
        searchKeyword,
        giftId,
        pageDivideId,
        channelType: 'SELF',
    };

    try {
        if (!recordPointHasDone.reportApi) {
            recordPointHasDone.reportApi = true;
        }

        const res = await post({
            url,
            data,
            useH5Guard: true,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        Toast({ message: '获取商家信息失败', position: 'bottom' });
        throw error;
    }
};
/**
 * 活动页面tab列表查询
 */
const getCategoryInfo = async () => {
    const rest = await getOadParams();

    const url = '/act/ge/getShowCateList';
    const data = { ...rest, actId };

    try {
        const res = await post({
            url,
            data,
            needToLogan: true,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        Toast({ message: '获取活动页面品类信息失败', position: 'bottom' });
        throw error;
    }
};

/**
 * 活动页面结构信息查询
 */
const getStructConfig = async () => {
    const rest = await getOadParams();
    const url = '/act/ge/getStructConfig';
    const data = { ...rest, actId };

    try {
        const res = await post({
            url,
            data,
            needToLogan: true,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        Toast({ message: '获取活动页面配置信息失败', position: 'bottom' });
        throw error;
    }
};

/**
 * 前端页面状态上报接口
 * @param {string} domId - 生成传递给后端的domID字符串，该字符串用来描述页面实际展示的结构。
 * @param {object} expInfoParams - 实验参数，透传后端给的参数
 * @param {string} LXPageId - 上报灵犀的页面ID
 * @param {string} logType - 值为mc/mv,行为类型：mc点击行为，mv曝光行为
 * @returns
 */
const frontMonitorPageLog = async (domId, expInfoParams, LXPageId, logType) => {
    const rest = await getOadParams();
    const url = '/act/frontMonitor/pagelog';
    try {
        const data = {
            ...rest,
            domId,
            expInfoParams,
            LXPageId,
            actId,
            logType,
        };
        const res = await post({
            url,
            data,
        });
        return res;
    } catch (error) {
        _reportLX(url, error);
        throw error;
    }
};
/**
 * 查询历史搜索词
 * @returns {Object}
 */
const postSearchHistory = async () => {
    const rest = await getOadParams();
    try {
        const res = await post({
            url: '/act/uas/search/get_keyword_list',
            data: rest,
        });
        return res;
    } catch (error) {
        console.error(error);
        Toast({ message: '获取历史搜索词失败', position: 'bottom' });
        _reportLX('/act/uas/search/get_keyword_list', error);
    }
    return null;
};
/**
 * 删除历史搜索记录
 * @returns {Object}
 */
const deleteSearchHistory = async () => {
    const rest = await getOadParams();
    try {
        const resDelete = await post({
            url: '/act/uas/search/del_keyword_list',
            ...rest,
        });
        return resDelete;
    } catch (error) {
        console.error(error);
        Toast({ message: '删除历史搜索词失败', position: 'bottom' });
        _reportLX('/act/uas/search/del_keyword_list', error);
    }
    return null;
};
/**
 * 批量上报点击
 * @param {*} clkMonitors
 * @returns
 */
const multipleClickM = async (clkMonitors) => {
    const rest = await getOadParams();

    try {
        const resData = await post({
            url: '/act/ge/g_monitor_multi',
            data: {
                ...rest,
                clkMonitors,
            },
        });
        return resData;
    } catch (error) {
        console.error(error);
        _reportLX('/act/ge/g_monitor_multi', error);
    }
};

const http = {
    actGeClkM, // ignore
    actGeRecvVer4Multi, //  ignore
    gMonitorApi, // ignore
    actGetPoiList,
    getCategoryInfo,
    getStructConfig,
    frontMonitorPageLog, // ignore
    postSearchHistory,
    deleteSearchHistory,
    multipleClickM, // ignore
    getUserInfo,
};

export default http;
